<script setup lang="ts">
import { useEoTracking } from 'storyblok/services/eoTracking'
const isMenuOpen = ref(false)
const frame = useRoute().query.frame === 'true'
const sbApi = useStoryblokApiV2()

const data = (await sbApi.getStories<{ content: any; slug: 'ldjson' | 'navigation' | 'footer' | 'eotracking' }>({
  by_slugs: ['layout/*'],
})).stories
const ldjsonData = data.find(item => item.slug === 'ldjson')
const eoTracking = data.find(item => item.slug === 'eotracking')

useEoTracking(
  eoTracking?.content?.partnerIds,
  eoTracking?.content?.excludedReferrers,
)
useStoryblokBridge()
</script>

<template>
  <div>
    <div v-if="frame">
      <NuxtPage :frame="frame" />
    </div>
    <div v-else>
      <TheNavigation v-model:isMenuOpen="isMenuOpen" v-bind="data.find(item => item.slug === 'navigation')?.content" />
      <AppLdJson v-if="ldjsonData?.content" v-bind="ldjsonData.content" />
      <NuxtPage />
      <TheFooter v-bind="data.find(item => item.slug === 'footer')?.content" />
    </div>
  </div>
</template>
